import moment, {Moment} from "moment";
import {toast} from "react-toastify";
import {MaybeDate} from "./types/Maybe";


export const minActivityTime = new Date();
minActivityTime.setHours(7, 0);

export const maxActivityTime = new Date();
maxActivityTime.setHours(21, 0);


export function mapToObject(map: any) {
    const obj: any = [];

    map.forEach(
        (k: string, v: any) => {
            obj[v] = k;
        }
    )
    return {...obj};
}


export function showErrorsListInToast(title: string, errors: string[]) {
    const msgs: any = [];

    const toastMsg = function (title: string, errors: string[]) {
        return <>
            <div className={"font-weight-bold text-center w-100 border-bottom p-1 m-1"}>{title}</div>
            <ul className={"pt-3"}>
                {errors.map(e => e)}
            </ul>
        </>
    }

    errors.forEach(
        (m: string, mIdx: number) => msgs.push(<li key={mIdx}>{m}</li>)
    );

    toast.error(toastMsg(title, msgs), {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
    });

}

export function showMsgInToast(msg: string) {
    const toastMsg = function (msg: string) {
        return <>
            <div className={"font-weight-bold text-center w-100 p-1 m-1 text-center"}>{msg}</div>
        </>
    }

    toast.success(toastMsg(msg), {
        position: toast.POSITION.BOTTOM_CENTER
    });

}

export const ARRAY22 = Array.of(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22);
export const ARRAY_MONTHS_SHORT = Array.of('ЯНУ', 'ФЕВ', 'МАР', 'АПР', 'МАЙ', 'ЮНИ', 'ЮЛИ', 'АВГ', 'СЕП', 'ОКТ', 'НОЕ', 'ДЕК');
export const ARRAY_MONTHS_FULL = Array.of('Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни', 'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември');

export const DICT = new Map<string, string>(
    []
);

export function translateError(e: string) {
    // debugger
    let err: string = e;
    // @ts-ignore
    for (const [key, value] of DICT.entries()) {
        err = err.replace(key, value);
    }

    return err;
}

export function translate(text: string) {
    return translateError(text);
}

export function translateDay(s: string) {
    return s.replace('Mon', 'Пон')
        .replace('Tue', 'Вто')
        .replace('Wed', 'Сря')
        .replace('Thu', 'Четв')
        .replace('Fri', 'Пет')
        .replace('Sat', 'Съб')
        .replace('Sun', 'Нед');
}

export function minutesToHours(m: number, suffix: string = ""): string {
    if (m === 0) return '';

    const _h = Math.floor(m / 60);
    const _m = m % 60;

    return ("00" + _h).substr(-2) + ":" + ("00" + _m).substr(-2) + suffix;
}

export function zeroToEmptyString(text: string | number | undefined | null, suff: string = '') {
    if (!text) return "";
    return (!text || (text == "0") || (text == 0) || (text == "NaN")) ? "" : text + suff;
}

export function zeroToEmptyStringAsNumber(text: string | number | undefined | null, suff: string = '') {
    if (!text) return "";
    let newVal: string = zeroToEmptyString(text).toString();
    return (newVal && newVal !== "") ? Number.parseFloat(newVal).toFixed(2) + suff : '';
}

export function zeroToEmptyStringAsCurrency(text: string | number, suff: string = '') {
    let newVal: string = zeroToEmptyString(text.toString()).toString();
    return (newVal && newVal !== "") ? Number.parseFloat(newVal).toFixed(2) + suff : '';
}

export function zeroToEmptyStringAsCurrencyWithCommas(text: string | number | undefined | null, suff: string = '') {
    // reuse zeroToEmptyString which treats 0/NaN/null/undefined as empty
    const newVal = zeroToEmptyString(text as any).toString();
    if (!newVal || newVal === '') return '';
    // parse and fix to 2 decimals, then add commas
    const parsed = Number.parseFloat(newVal as string);
    if (!isFinite(parsed)) return '';
    return numberWithCommas(parsed.toFixed(2)) + suff;
}

export function numberWithCommas(x: any) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}

export function nullsToEmptyString(obj: any) {
    Object.keys(obj).forEach(
        $key => {
            if (obj[$key] === "null" || obj[$key] === null) obj[$key] = '';
        }
    );

    return obj;
}

export function textToFloat(value: string | number, defaultValue: any = null): number | null {
    if (typeof value === "number") return value;

    const _v = value ? Number.parseFloat(value.replace(',', '.')) : defaultValue;
    return isNaN(_v) ? defaultValue : _v;
}

export function editTextToFloat(value: string): string {
    const _v = Number.parseFloat(value.replace(',', '.'));
    return isNaN(_v) ? '' : value;
}

export function textToInt(value: string, defaultValue: any = null): number | null {
    const _v = Number.parseInt(value.replace(',', '.'));
    return isNaN(_v) ? defaultValue : _v;
}

export function onlyPozitive(value: number | null): number | null {
    return value !== null && value >= 0 ? value : null;
}

export function onlyPozitiveText(value: string | null): string | null {
    const _v = textToFloat(value || '');
    return _v !== null && _v >= 0 ? value : null;
}

export function momentToString(date: Moment) {
    return date.format('DD.MM.YYYY')
}

export function dateToString(date: Date | null | undefined) {
    return date ? moment(date).format('DD.MM.YYYY') : ''
}

export function dateTimeToString(date: Date | null | undefined) {
    return date ? moment(date).format('DD.MM.YYYY - HH:mm ч.') : ''
}

export function timeToString(date: Date | null | undefined) {
    return date ? moment(date).format('HH:mm') : ''
}

export function timeDiffToString(start: MaybeDate, end: MaybeDate, withDelta: number) {
    if(!start || !end) {
        return "";
    }
    const date1 = moment(start);
    const date2 = moment(end);
    date2.subtract(withDelta, "minutes");
    const duration = moment.duration(date2.diff(date1));
    const hDiff = Math.floor(duration.asHours());
    const _mDiff = duration.asMinutes();
    const mDiff = _mDiff - hDiff * 60;

    return hDiff.toString() + "ч" + (mDiff ? " и " + mDiff.toString().padStart(2, '0') + "мин": "");
}

export function timeDiffInMinutes(start: MaybeDate, end: MaybeDate, withDelta: number) {
    if(!start || !end) {
        return 0;
    }
    const date1 = moment(start);
    const date2 = moment(end);
    date2.subtract(withDelta, "minutes");
    const duration = moment.duration(date2.diff(date1));
    return Math.ceil(duration.asMinutes());
}

export function minutesToHoursAsString(minutes: number): string {
    if(minutes < 1) return  "0ч";

    let hours = Math.trunc(minutes / 60);
    let min = Math.ceil(minutes - hours * 60);
    if(min > 58) {
        hours++;
        min = 0;
    }
    return hours.toString() + "ч" + (min ? " и " + min.toString().padStart(2, '0') + "мин": "");
}

export function minutesToHoursAsShortString(minutes: number): string {
    if(minutes < 1) return  "0ч";

    let hours = Math.trunc(minutes / 60);
    let min = Math.ceil(minutes - hours * 60);
    if(min > 58) {
        hours++;
        min = 0;
    }
    return hours.toString() + (min ? ":" + min.toString().padStart(2, '0'): "")+"ч";
}

export function hoursAsShortString(hours: number): string {
    const h = Math.trunc(hours);
    const min = Math.ceil((hours - h) * 60);

    if(h + min < 1) return  "";
    return h.toString() + (min ? ":" + min.toString().padStart(2, '0'): "")+"ч";
}

export function stringToDate(date: string | null | undefined): Date | undefined {
    if (!date) return undefined;

    const tryDate = moment(date, "DD.MM.YYYY");
    if (tryDate.isValid()) return tryDate.toDate()
    else return undefined;
}

export function getDayOfWeek(date: Date) {
    const daysOfWeek = ['Неделя', 'Понеделник', 'Вторник', 'Сряда', 'Четвъртък', 'Петък', 'Събота'];
    const dayIndex = date.getDay();
    return daysOfWeek[dayIndex];
}

export function dateWithZeroTime(date: Date | null | undefined): Date | undefined {
    if (!date) return undefined;
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
}

export function dateWithMaxTime(date: Date | null | undefined): Date | undefined {
    if (!date) return undefined;
    const newDate = new Date(date);
    newDate.setHours(23, 59, 59, 999);
    return newDate;
}


export function getDatesInPeriod(periodFrom: Date, periodTo: Date): Date[] {
    const dates: Date[] = [];
    const _pFrom = dateWithZeroTime(periodFrom)!;
    const _pTo = dateWithZeroTime(periodTo)!;
    let current = new Date(_pFrom);
    while(current <= _pTo) {
        dates.push(new Date(current));
        current.setDate(current.getDate() + 1);
    }
    return dates;
}
export function getDateAsPeriod(date: Date): [Date, Date] {
    const _pFrom = dateWithZeroTime(date)!;
    const _pTo = new Date(_pFrom);
    _pTo.setDate(_pTo.getDate()+1);
    return[_pFrom, _pTo];
}

export function isIterable(value: any) {
    return Symbol.iterator in Object(value);
}

export function getShiftName(id: number) {
    switch (id) {
        case 1:
            return "Първа смяна";
        case 2:
            return "Втора смяна";
        case 3:
            return "Редовна смяна";
    }
    return '';
}

export function removeEmptyFields<T>(obj: T | null | undefined): T | null {
    if (!obj) return null;
    return removeUndefinedFields(obj);
}

export function getRequiredActivitiesCntBySizeGroup(campaign: any, sg: string) {
    let cnt = 0;
    switch (sg) {
        case "Малък клиент" :
            cnt = campaign.get('retryCntSmall') || 0;
            break;
        case "Среден клиент" :
            cnt = campaign.get('retryCntMid') || 0;
            break;
        case "Голям клиент" :
            cnt = campaign.get('retryCntBig') || 0;
            break;
        case "Ключов клиент/дилър" :
            cnt = campaign.get('retryCntKey') || 0;
            break;
        default:
            cnt = 0;
    }
    return cnt;
}


export function removeUndefinedFields<T>(obj: T | null): T | null {
    if (obj === null) return null;
    let newObj = {...obj};
    const keys = Object.keys(newObj as Object);
    keys.forEach(
        (k: string) => {
            // @ts-ignore
            if (newObj[k] === undefined || newObj[k] === null) delete newObj[k];
        }
    );
    return newObj;
}

export function firebaseDateToDate(fbDate: any): Date {
    if (!fbDate) return fbDate;

    const _date = moment(fbDate);
    if (_date.isValid()) return fbDate;
    // @ts-ignore
    return new Date(fbDate.seconds * 1000);
}

export function checkOverlapTimes(d1Start: Date, d1End: Date,  d2Start: Date, d2End: Date): boolean {
    return (d1Start >= d2Start && d1Start < d2End) || (d2Start >= d1Start
        && d2Start < d1End);
}

export const getFirstWeekStartDate = (date: Date): Date => {
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const dayOfWeek = firstDayOfMonth.getDay();
    const diff = firstDayOfMonth.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    return new Date(firstDayOfMonth.setDate(diff));
};

export const getLastWeekEndDate = (date: Date): Date => {
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const dayOfWeek = lastDayOfMonth.getDay();
    const diff = 7 - dayOfWeek;
    return new Date(lastDayOfMonth.setDate(lastDayOfMonth.getDate() + diff));
};



